import React from "react";
import { useTranslation } from "react-i18next";
import { ExportButton } from "./exportButton";
import {
  useAuthentication,
  useExportData,
  useRetrieveCurrentPlanzone,
  useRetrieveZonesProjectsReports,
} from "@planzone/view-models";
import {
  ExportsDataTypes,
  ExportsFormats,
  Identifiable,
  Resource,
} from "@planzone/dto";
import { ReportsList } from "./reportsList";
import { Header } from "./header";
import { FilterForm } from "./filterForm";
import { Props } from "./types";
import { Loader } from "./loader";
import styles from "./styles.scss";

function ReportsPage({ header, sideBar }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { account } = useAuthentication();
  const {
    reports,
    isRequestFailure,
    isRequestSuccess,
    isRequestPending,
    retrieveZonesProjectsReports,
  } = useRetrieveZonesProjectsReports();
  const { isRequestPending: isExportRequestPending, exportData } =
    useExportData();
  const [filter, setFilter] = React.useState<{
    resources: Identifiable<Resource>[];
    date: "" | "old" | "new";
  }>({
    date: "",
    resources: [],
  });

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestFailure &&
      !isRequestSuccess &&
      retrieveZonesProjectsReports(planzone);
  }, [
    planzone,
    retrieveZonesProjectsReports,
    isRequestFailure,
    isRequestSuccess,
    isRequestPending,
  ]);

  return (
    <div className={styles.reportsPage}>
      {header}
      <div className={styles.filters}>
        <FilterForm filter={filter} setFilter={setFilter} />
      </div>
      <div className={styles.main}>
        {sideBar}
        <div className={styles.list}>
          <div className={styles.header}>
            <Header />
          </div>
          {isRequestPending ? (
            <Loader />
          ) : (
            <>
              <div className={styles.reportsList}>
                <ReportsList
                  reports={reports}
                  authorFilter={filter.resources}
                  sort={filter.date}
                />
              </div>
            </>
          )}
          {/*<div className={styles.exportButton}>*/}
          {/*  <ExportButton*/}
          {/*    click={() =>*/}
          {/*      !isExportRequestPending &&*/}
          {/*      exportData({*/}
          {/*        format: ExportsFormats.EXCEL,*/}
          {/*        author: account,*/}
          {/*        fileName: "reports",*/}
          {/*        data: {*/}
          {/*          type: ExportsDataTypes.PROJECT_REPORTS,*/}
          {/*          data: { reports, planzone, planzone },*/}
          {/*        },*/}
          {/*      })*/}
          {/*    }*/}
          {/*  />*/}
          {/*</div>*/}
        </div>
      </div>
    </div>
  );
}

export { ReportsPage };
